module.exports = __webpack_public_path__ + "img/cadastro-clientes2.eb258f72.jpg";